import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone';

import ModalContainer from '../../controlCostos/ModalContainer';
import DetailsSelector from '../../controlCostos/components/DetailsSelector';
import { costsControlApi } from '../../../api';
import cogoToast from 'cogo-toast';
import ServiceOrder from '../../controlCostos/components/details/ServiceOrder/ServiceOrder';
import { messageSummary, NOTIFICATION_EVENT } from '../../../core/webNotifications';

const TableAbiertas = (props) => {
   const [solicitudes, setSolicitudes] = useState([]);
   const [loadingSolicitudes, setLoadingSolicitudes] = useState(false);
   const [serviceModal, setServiceModal] = useState(false);
   const [selectedItem, setSelectedItem] = useState({});
   const [enableOrderList, setEnableOrderList] = useState([]);

   // requestId → {unread, total}. Vacío si el servidor aún no tiene
   // mensajes (migración 0004): entonces no se muestra el botón.
   const [threads, setThreads] = useState(null);

   const actions = ['Añadir Servicio', 'Editar Servicio'];

   useEffect(() => {
      let alive = true;
      const load = async () => {
         const res = await messageSummary();
         if (!alive) return;
         if (!res.ok) {
            setThreads(null);
            return;
         }
         const map = {};
         (res.data || []).forEach((t) => (map[t.requestId] = t));
         setThreads(map);
      };
      load();
      const onNotice = (e) => e.detail && e.detail.type === 'message' && load();
      window.addEventListener(NOTIFICATION_EVENT, onNotice);
      return () => {
         alive = false;
         window.removeEventListener(NOTIFICATION_EVENT, onNotice);
      };
   }, [props.chatVersion]);

   useEffect(() => {
      setSolicitudes(props.solicitudes);
      setLoadingSolicitudes(props.loadingSolicitudes);
   }, [props.solicitudes, props.loadingSolicitudes]);

   useEffect(() => {
      (async () => {
         setEnableOrderList(await costsControlApi.getOrdersList());
      })();
   }, []);

   const handleEtitItem = (newValue, attrToChange) => {
      setSelectedItem((prevState) => ({
         ...prevState,
         [attrToChange]: newValue,
      }));
   };

   const validateNewOrder = (item) =>
      item.solicitud &&
      item.description &&
      item.type_of_service &&
      item.status &&
      item.tasks;

   const handleSaveItem = (e, item) => {
      e.preventDefault();
      if (!validateNewOrder(item)) {
         cogoToast.error('Faltan campos por llenar', { position: 'top-right' });
         return;
      }

      const saveStatus = costsControlApi.createOrder(item);
      if (!saveStatus?.error) {
         setServiceModal(false);
      }
   };

   const handleCancelOrClose = () => {
      setServiceModal(false);
   };

   return (
      <div className="table-responsive full">
         {serviceModal && (
            <ModalContainer
               size="normal"
               title={selectedItem.title}
               btnSuccessText="Guardar"
               onCancel={handleCancelOrClose}
               onClose={handleCancelOrClose}
               onSuccess={(e) => handleSaveItem(e, selectedItem)}>
               <DetailsSelector
                  select={ServiceOrder}
                  item={selectedItem}
                  onEditItem={handleEtitItem}
               />
            </ModalContainer>
         )}
         <table>
            <thead>
               <tr>
                  <th className="text-center">No Solicitud</th>
                  <th className="text-center">Estado</th>
                  <th className="text-center">Fecha</th>
                  <th className="text-center">Proyecto</th>
                  <th className="text-center">Unidad</th>
                  <th className="text-center th-md"></th>
                  {threads && <th className="text-center th-md"></th>}
                  <th className="text-center th-md"></th>
               </tr>
            </thead>
            <tbody>
               {loadingSolicitudes ? (
                  <tr>
                     <td className="text-center" colSpan={threads ? 8 : 7}>
                        <i className="fas fa-spinner fa-spin"></i>
                     </td>
                  </tr>
               ) : solicitudes ? (
                  solicitudes?.length === 0 ? (
                     <tr>
                        <td className="text-center" colSpan={threads ? 8 : 7}>
                           Sin datos que mostrar
                        </td>
                     </tr>
                  ) : (
                     solicitudes
                        .slice((props.page - 1) * 15, props.page * 15)
                        .map((solicitud, key) => (
                           <tr key={key}>
                              <td className="text-center">{solicitud.NoSolicitud}</td>
                              <td className="text-center">{solicitud.Estado}</td>
                              <td className="text-center">
                                 {moment(solicitud.Fecha)
                                    .zone('+05:00')
                                    .format('DD-MM-YYYY')}
                              </td>
                              <td className="text-center">{solicitud.NombreProyecto}</td>
                              <td className="text-center">{solicitud.Numero}</td>
                              <td className="text-center">
                                 <button
                                    className=" btn-small btn-empty"
                                    type="button"
                                    onClick={() => {
                                       props.setSolicitud(solicitud);
                                    }}>
                                    <i className="font-small fas fa-eye" />
                                 </button>
                              </td>
                              {threads && (
                                 <td className="text-center">
                                    <button
                                       className="btn-small btn-empty btn-chat-unread"
                                       type="button"
                                       title="Mensajes"
                                       onClick={() => props.openChat(solicitud)}>
                                       <i
                                          className={`font-small ${
                                             threads[solicitud.IdSolicitud] ? 'fas' : 'far'
                                          } fa-comments`}
                                       />
                                       {threads[solicitud.IdSolicitud] &&
                                          threads[solicitud.IdSolicitud].unread > 0 && (
                                             <span className="chat-dot">
                                                {threads[solicitud.IdSolicitud].unread}
                                             </span>
                                          )}
                                    </button>
                                 </td>
                              )}
                              <td className="text-center">
                                 {enableOrderList?.find(
                                    (item) => item.id_request === solicitud?.IdSolicitud
                                 ) ||
                                 (Number(solicitud?.IdEstado) !== 3 &&
                                    Number(solicitud?.IdEstado) !== 6 &&
                                    Number(solicitud.IdEstado) !== 10) ? (
                                    <button
                                       className="btn btn-empty btn-small color-white"
                                       onClick={() => {
                                          setServiceModal(true);
                                          setSelectedItem({
                                             title: actions[0],
                                             solicitud: solicitud,
                                          });
                                       }}>
                                       <i className="fas fa-plus-square" />
                                       &nbsp; Servicio
                                    </button>
                                 ) : (
                                    <button
                                       className="btn btn-empty btn-small color-white"
                                       disabled>
                                       <i className="fas fa-ban"></i>
                                       &nbsp; Servicio
                                    </button>
                                 )}
                              </td>
                           </tr>
                        ))
                  )
               ) : (
                  <tr>
                     <td className="text-center" colSpan={threads ? 8 : 7}>
                        Sin datos que mostrar
                     </td>
                  </tr>
               )}
            </tbody>
         </table>
      </div>
   );
};
export default TableAbiertas;
